module.exports = __webpack_public_path__ + "img/msc.b257c2ed.webp";